// PDF export using html2pdf.js
export async function exportReportToPDF(elementId, filename = 'WhatsNEXT-Report.pdf') {
  const element = document.getElementById(elementId);
  if (!element) {
    console.error('Export element not found:', elementId);
    return;
  }

  const html2pdf = (await import('html2pdf.js')).default;

  const opt = {
    margin: [0.3, 0.3, 0.3, 0.3],
    filename,
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      backgroundColor: '#000000',
      logging: false,
    },
    jsPDF: {
      unit: 'in',
      format: 'letter',
      orientation: 'portrait',
    },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
  };

  await html2pdf().set(opt).from(element).save();
}

// Format date for display
export function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

// Format score for display
export function formatScore(score) {
  if (score == null) return '—';
  return Number(score).toFixed(1);
}
